// Helper function to format pricing based on culture code and currency

export function currencyFormatter (number, desiredCurrency, cultureCode) {
  let options = {
    style: "currency",
    currency: desiredCurrency,
  }

  return new Intl.NumberFormat(cultureCode, options).format(number);
}